import { useEffect } from 'react'
import { useInView } from 'react-intersection-observer'
import { useSession } from 'next-auth/react'

import {
  CustomerTypes,
  extractCustomerFromClientSession
} from 'modules/customer'
import {
  ProductTypes,
  SwipeableSlider,
  viewProductList
} from 'modules/products'
import { SeoListName } from 'shared/analytics'
import { PATHS } from 'shared/utils/paths'
import { addTestId } from 'shared/utils/tests'

const BESTSELLERS_LIST_NAME = SeoListName.BESTSELLERS_LIST_NAME

interface BestsellersSectionProps {
  products: ProductTypes[]
}

const BestsellersSection = ({ products }: BestsellersSectionProps) => {
  const session = useSession()
  const user: CustomerTypes | undefined = extractCustomerFromClientSession(session)

  const productsToDisplay = products?.slice(0, 10)
  const [ref, inView] = useInView({ triggerOnce: true, initialInView: false })

  useEffect(() => {
    if (session?.status !== 'loading' && inView) {
      viewProductList({
        user,
        products,
        listName: BESTSELLERS_LIST_NAME
      })
    }
  }, [session, inView])

  return (
    <section ref={ref} {...addTestId('homepage-section-bestsellers')}>
      <SwipeableSlider
        id='bestsellery'
        title='Wasze ulubione'
        seoButtonPlace='/'
        products={productsToDisplay}
        redirectButton={{
          label: 'Zobacz wszystkie',
          path: PATHS.bestsellers
        }}
        redirectTile={{
          label: 'Zobacz wszystkie',
          path: PATHS.bestsellers
        }}
        listName={BESTSELLERS_LIST_NAME}
      />
    </section>
  )
}

export default BestsellersSection
